/**
 * Central definitions for localStorage and refresh-scoped session keys.
 * Custom window events live in {@link ./events}.
 */

const LEGACY_ACTIVE_TRADE_KEY = 'tcgeasy_active_trade_id'

export const localStorageKeys = {
  /** Per-org key for resuming the in-store transaction (trade) builder. */
  activeTradeId: (orgId: string) => `${LEGACY_ACTIVE_TRADE_KEY}:${orgId}`,
  /** @deprecated global key — migrate to {@link localStorageKeys.activeTradeId} */
  legacyActiveTradeId: LEGACY_ACTIVE_TRADE_KEY,
  tradePaymentMethod: (orgId: string) => `tcgeasy_trade_payment_method:${orgId}`,
  chunkRecoveryCount: 'tcgeasy:chunk-recovery-count',
  chunkRecoveryAttempted: 'tcgeasy:chunk-recovery-attempted',
  swUpdateReloadAttempted: 'tcgeasy:sw-update-reload-attempted',
  appVersionReloadAttempted: 'tcgeasy:app-version-reload-attempted',
  inventoryDensity: 'tcgeasy:inventory-density',
  /** Desktop sidebar pinned open ('1') or folded to the icon rail ('0'); unset = by screen width. */
  sidebarPinned: 'tcgeasy:sidebar-pinned',
} as const

/** Keys used with refresh-scoped session helpers (see `useClearRefreshScopedSessionOnRouteLeave`). */
export const sessionStorageKeys = {
  catalogSelection: 'tcgeasy:catalogSelection',
  inventorySelection: 'tcgeasy:inventorySelection',
  qrSelection: 'tcgeasy:qrSelection',
} as const

export const activeTradeIdKeyPrefix = LEGACY_ACTIVE_TRADE_KEY
